<template>
  <!-- 代付详情 -->
  <el-dialog
    :title="'分账详情'"
    :visible.sync="visible"
    width="800px"
    @close="handleClose"
    destroy-on-close
  >
    <div class="ledger-detail-modal-wrap">
      <div class="ledger-detail-content">
        <div class="ledger-detail-left-column">
          <p><span>分账创建时间 :</span></p>
          <p><span>部门/门店 :</span></p>
          <p><span>订单总额 :</span></p>
          <p><span>手续费 :</span></p>
          <p><span>订单日期 :</span></p>
          <p><span>分账状态 :</span></p>
        </div>
        <div class="ledger-detail-right-column">
          <p>
            <span>{{ detailForm.createTime || '-' }}</span>
          </p>
          <p>
            <span>{{ detailForm.departmentName || '-' }}</span>
          </p>
          <p>
            <span>￥ {{ detailForm.orderAmount | numberFormat }}</span>
          </p>
          <p>
            <span>￥ {{ detailForm.fee | numberFormat }}</span>
          </p>
          <p>
            <span>{{
              (detailForm.payTime && String(detailForm.payTime).substring(0, 10)) || '-'
            }}</span>
          </p>
          <p>
            <span>{{ detailForm.statusName || '-' }}</span>
          </p>
        </div>
      </div>
      <el-table :data="tableData">
        <el-table-column label="收款商户名称">
          <template slot-scope="scope" width="240px">
            <p>
              {{ scope.row.payeeName || '-' }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="分账金额" width="140px">
          <template slot-scope="scope">
            <p>
              {{ scope.row.subAccountAmount | numberFormat }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="分账比例" width="140px">
          <template slot-scope="scope">
            <p>{{ scope.row.subAccountRatio | numberFormat('5') }}%</p>
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <el-tooltip
              v-if="scope.row.remark"
              effect="dark"
              :content="scope.row.remark"
              placement="top-start"
            >
              <p class="ledger-table-comments">
                {{ scope.row.remark }}
              </p>
            </el-tooltip>
            <p v-else>
              -
            </p>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose" size="small">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'OrderDetailModal',
  props: {
    formData: Object,
    detailVisible: Boolean,
  },
  data() {
    return {
      visible: false,
      detailForm: {
        companyId: '',
        createTime: '',
        customerName: '',
        customerNo: '',
        departmentId: '',
        departmentName: '',
        detailList: [],
        fee: 0,
        id: '',
        orderAmount: 0,
        orderNo: '',
        payTime: '',
        status: 1,
        statusName: '',
        subAccountTime: null,
        subName: '',
        taxNo: '',
        tradeOrderNo: '',
        tradeTempNo: '',
      },
      tableData: [],
    };
  },
  watch: {
    detailVisible(newVal) {
      this.visible = newVal;
    },
    formData(newVal) {
      this.detailForm = newVal;
      this.tableData = newVal.detailList || [];
    },
  },
  methods: {
    handleClose() {
      this.$emit('handleClose');
    },
  },
};
</script>
<style scoped lang="scss">
.ledger-detail-modal-wrap {
  max-height: 490px;
  overflow-y: auto;
  .ledger-detail-content {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
    margin-bottom: 20px;
    .ledger-detail-right-column {
      margin-left: 50px;
    }
    .ledger-detail-right-column > p,
    .ledger-detail-left-column > p {
      height: 24px;
      line-height: 24px;
    }
  }
}
.ledger-table-comments {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
